import axios from 'axios';
import { BASE_BACKEND_URL } from 'env';

import { PRICEMOOV_AUTH_KEY } from 'redesign/helpers/auth';
import localStorage from 'redesign/helpers/localStorage';
import logger from 'services/logger/logger';

export const getHeaders = (addAuthentication = true) => {
    const h: { [k: string]: string } = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    };
    if (addAuthentication) {
        const pricemoovAuth = localStorage.get(PRICEMOOV_AUTH_KEY);
        if (pricemoovAuth) {
            h.Authorization = `jwt ${JSON.parse(pricemoovAuth).token}`;
        }
    }
    return h;
};

class ApiClient {
    private baseURL?: string;

    protected paths: { [k: string]: string };

    public constructor() {
        this.baseURL = BASE_BACKEND_URL;
        this.paths = {};

        axios.interceptors.response.use(
            response => response,
            error => {
                // If we have an HTTP error
                if (error.response) {
                    if (error.response.status === 403) {
                        logger.debug('An unexpected 403 error occured. Logging out...');
                    }
                }
                return Promise.reject(error);
            }
        );
    }

    public setPath(key: string, value: string) {
        this.paths[key] = value;
    }

    public url(key: string) {
        return `${this.baseURL}${this.paths[key]}`;
    }

    public rawUrl(url: string) {
        return `${this.baseURL}${url}`;
    }
}

export default ApiClient;
